import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const CouponLoginHeaderBanner = ({
  textContent,
}: {
  textContent: string;
}) => {
  return (
    <BannerWrapper>
      <Icon
        asset={GenericIconName.Coupon}
        size="S"
        fill={COLORS.PrimaryCoupon}
      />
      <span>{textContent}</span>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: ${COLORS.BackgroundCoupon};
  color: ${COLORS.PrimaryCoupon};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  gap: 8px;
`;
